import { useNotifications, useMarkNotificationRead } from '@/features/notifications/notifications.queries';
import { NotificationItem } from '@/components/notifications/NotificationItem';
import { EmptyState } from '@/components/common/EmptyState';

export function NotificationList() {
  const { data, isLoading } = useNotifications();
  const markRead = useMarkNotificationRead();

  if (isLoading) return <p>Loading…</p>;
  if (!data?.length) return <EmptyState title="You're all caught up" />;

  return (
    <ul className="notification-list">
      {data.map((n) => (
        <NotificationItem key={n.notificationId} notification={n} onRead={(id) => markRead.mutate(id)} />
      ))}
    </ul>
  );
}
